import React, { SyntheticEvent, useEffect, useState } from "react";
import { SaveOutlined } from "@ant-design/icons";
import YudlButton from "../../components/Button";
import YudlInput from "../../components/Input";
import SectionWrapper from "../../components/SectionWrapper";
import YudlSelect from "../../components/Select";
import { DESIGNATION } from "../../constants";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { updateProfile } from "../../redux/auth/authThunk";

const InfoSection = () => {
    const [inValidSelect, setInValidSelect] = useState({ designation: false });
    const [formData, setFormData] = useState({ name: "", email: "", designation: "", company: "", photo: "" });

    const { user } = useAppSelector(state => state.auth);

    const dispatch = useAppDispatch();

    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            name: user?.name || "",
            email: user?.email || "",
            designation: user?.designation || "",
            company: user?.company || "",
            photo: user?.photo || "",
        }));
    }, [user]);

    const handleSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!formData.designation) {
            setInValidSelect(prevState => ({ ...prevState, designation: true }));
        }

        if (!e.currentTarget.checkValidity()) {
            e.currentTarget.classList.add("was-validated");
            return;
        }

        e.currentTarget.classList.remove("was-validated");

        if (!formData.designation) return;

        const data = {
            ...user,
            name: formData?.name || user?.name,
            designation: formData?.designation || user?.designation,
            photo: formData?.photo || user?.photo,
            company: formData?.company || user?.company,
        };

        dispatch(updateProfile({ userId: user?.userId, data }));
    };

    const handleOnchange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (key: string) => (val: string) => {
        setFormData(prev => ({ ...prev, [key]: val }));
        setInValidSelect(prevState => ({ ...prevState, [key]: false }));
    };

    return (
        <SectionWrapper>
            <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <YudlInput
                            value={formData.name}
                            onChange={handleOnchange}
                            name="name"
                            label="Full Name"
                            placeholder="Enter your full Name"
                            invalidFeedback="* required"
                            title="* required"
                            required
                        />
                    </div>
                    <div className="col-md-6">
                        <YudlInput
                            value={formData.company}
                            onChange={handleOnchange}
                            name="company"
                            label="Company Name"
                            placeholder="Enter your company Name"
                            invalidFeedback="* required"
                            title="* required"
                            required
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <YudlInput value={formData.email} name="email" label="Email" readOnly />
                    </div>
                    <div className="col-md-6">
                        <YudlSelect
                            onChange={handleSelectChange("designation")}
                            value={formData.designation}
                            labelField={"title"}
                            valueField={"title"}
                            label="Designation in Company"
                            placeholder="Select your designation"
                            invalidFeedback="* required"
                            isInvalid={inValidSelect.designation}
                            title="* required"
                            options={DESIGNATION}
                        />
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <YudlButton htmlType="submit" icon={<SaveOutlined />} children="Save" className="my-4" />
                </div>
            </form>
        </SectionWrapper>
    );
};

export default InfoSection;
